import { put, takeLatest, call } from 'redux-saga/effects';

import { obtenerChatsDesdeServidor } from '../actions/creators/giotalk.actioncreator';
import { CORE_OBTENER_ENTIDADES_BASICAS_REQUEST, CORE_OBTENER_ENTIDADES_BASICAS_EXTRA_REQUEST } from '../actions/constants/core.constants';
import { AUTH_PERMISOS_REQUEST, AUTH_SUCCESS } from '../actions/constants/auth.constants';
import { APP_GET_LOGO_REQUEST, APP_GET_LOGO_REQUEST_SUCCESS, APP_GET_LOGO_REQUEST_FAILURE} from '../actions/constants/app.constants';
import getPayload from '../../helpers/jwt.helper';
import request from '../../helpers/request.helper';
import { authRequest } from '../../helpers/request.helper';

function* initialize({ payload }) {
  const { token } = payload;
  const tokenPayload = getPayload(token);
  const lang = tokenPayload ? tokenPayload.lang : null;
  if (lang) {
    localStorage.setItem('app_language', lang);
  }
  yield put({ type: AUTH_PERMISOS_REQUEST });
  yield put({ type: CORE_OBTENER_ENTIDADES_BASICAS_REQUEST });
  yield put(obtenerChatsDesdeServidor());
  const response = yield call(request, { url: 'version', method: 'GET' });
}

function* getLogo() {
  const params = {
    url: 'api/generico/logotipo',
    method: 'GET',
  };
  try {
    const {
      logotipo_base64
    } = yield call(authRequest, params);


    yield put({ type: APP_GET_LOGO_REQUEST_SUCCESS, payload: logotipo_base64 });
  } catch (error) {
    yield put({ type: APP_GET_LOGO_REQUEST_FAILURE });
  }
}

function* appSaga() {
  yield takeLatest(AUTH_SUCCESS, initialize);
  yield takeLatest(APP_GET_LOGO_REQUEST, getLogo);
}



export default appSaga;
